import { render, staticRenderFns } from "./warehouseInventory.vue?vue&type=template&id=455b5ef4&scoped=true&"
import script from "./warehouseInventory.vue?vue&type=script&lang=js&"
export * from "./warehouseInventory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "455b5ef4",
  null
  
)

export default component.exports